import React from 'react';
import { useSelector } from 'react-redux';

const PaymentHistoryWidget = ({ value, fetchHtmlTemplate }) => {
  const user = useSelector((state) => state.users.user);

  // For parsing and injecting function
  const populateTemplate = (template, data) => {
    let result = template;
    data.forEach(({ inv_date, amount }) => {
      // Assuming template has placeholders like {{inv_date}} and {{amount}}, or you can define your own syntax
      console.log('Populate template: ', date, ' amount ', amount);
      result = result.replace('{{date}}', date).replace('{{amount}}', amount);
      // For multiple replacements, might do more complex processing or join multiple blocks
    });
    return result;
  };

  let paymentArray = [];
  try {
    // If value is passed as a string, parse it
    console.log('clean up value: ', value);
    let cleanValue = value.replace(/'/g, '"');
    paymentArray = typeof cleanValue === 'string' ? JSON.parse(cleanValue) : [];
  } catch (error) {
    // console.error('Failed to parse payment history JSON:', error);
    console.log('Failed to parse payment history JSON:', value);
    paymentArray = [];
  }

  if (!Array.isArray(paymentArray)) {
    console.log('payment_history value is empty');
    return null;
  }

  return (
    <div>
      {paymentArray.length == 0 ? (
        <div>No invoices yet</div>
      ) : (
        <div>
          <ul>
            {paymentArray.map((item, index) => {
              // Construct the URL or use your HTML template here
              const invoiceUrl = `/invoice?date=${encodeURIComponent(item.date)}&amount=${encodeURIComponent(item.amount)}`;

              return (
                <li key={index}>
                  <a
                    href={invoiceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Invoice for R{item.amount} on {item.date}
                  </a>
                </li>
              );
            })}
          </ul>
          <p className="invoices-list-helper subscription-help-text">
            If you enter your company details on your personal information they
            will appear on your invoices
          </p>
        </div>
      )}
    </div>
  );
};

export default PaymentHistoryWidget;
